import { render, staticRenderFns } from "./UploadDocIcon.vue?vue&type=template&id=48ca84fc"
import script from "./UploadDocIcon.vue?vue&type=script&lang=js"
export * from "./UploadDocIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports